import e from "./_overArg.js";
var t = e(Object.keys, Object);
const a = t;
export {
  a as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_nativeKeys.js
// module id = 1540
// module chunks = 67